<template>
   <div class="content-container">
     <ContentBox :title=" mode == 'edit' ? '编辑广告主' : '创建广告主'" class="content-box">
       <template v-if="registerType === 0">
         <el-form
        class="demo-ruleForm"
        label-width="120px"
        label-position="left"
        :model="companyForm"
        ref="companyForm"
        hide-required-asterisk
        >
        <el-form-item label="类型">
          <el-radio-group v-model="registerType" :disabled="mode === 'edit' && companyForm.partnerStatus === 0">
            <el-radio-button size="medium" :label="0">企业</el-radio-button>
            <el-radio-button size="medium" :label="1">个人</el-radio-button>
          </el-radio-group>
        </el-form-item>
          <el-form-item prop="partnerName" :rules="[{ required: true, message: '请输入公司名称', trigger: 'blur' }]">
            <span slot="label">
              <span>公司名称</span>
              <span class="sub-title">(必填)</span>
            </span>
            <el-autocomplete
              v-model="companyForm.partnerName"
              :trigger-on-focus="false"
              :fetch-suggestions="querySearchAsync"
              clearable
              value-key="cumName"
              placeholder="请输入公司名称"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="证件类型">
             <div class="demo-ruleForm-box">
            <el-select v-model="companyForm.companyNature" placeholder="请选择" class="demo-ruleForm-half-select">
                <el-option label="企业" :value="0"></el-option>
                <el-option label="个体账户" :value="1"></el-option>
                <el-option label="政府组织机构/事业单位" :value="2"></el-option>
                <el-option label="港澳台" :value="3"></el-option>
                <el-option label="其他机构" :value="4"></el-option>
                <el-option label="海外" :value="5"></el-option>
            </el-select>
            <el-select v-model="companyForm.licenseType" placeholder="请选择" class="demo-ruleForm-half-select">
                <el-option label="组织机构代码代号" :value="0"></el-option>
                <el-option label="企业营业执照统一社会信用代码" :value="1"></el-option>
                <el-option label="企业营业执照注册号" :value="2"></el-option>
            </el-select>
            <div class="remark-tip">优先选择"营业执照统一社会信用代码";若无则按照实际情况填写</div>
             </div>
          </el-form-item>
          <el-form-item label="资质照片" class="qualify-item">
            <div class="demo-ruleForm-box">
            <el-upload
              class="avatar-uploader"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleLicenseSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="companyForm.license !== ''" :src="companyForm.license" class="avatar">
               <div v-else class="text-wrapper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="text-tip">请上传资质编号清晰可见的相关资质照片,仅持jpg、png、jpeg格式图片,小于5M</div>
              </div>
            </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="资质编号">
            <div class="demo-ruleForm-box">
            <el-input v-noEmoji v-model="companyForm.licenseSn" placeholder="请先选择证件类型,再填写资质编号" class="demo-ruleForm-input"/>
            <div class="remark-tip">请确保所填资质编号与资质照片上的一致</div>
            </div>
          </el-form-item>
          <el-form-item label="证件有效期">
            <div class="demo-ruleForm-box">
                <el-select v-model="companyForm.licenseUsefulLifeType" placeholder="请选择" :class="companyForm.licenseUsefulLifeType === 0 ? 'demo-ruleForm-half-select' : 'demo-ruleForm-select'">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <template v-if="companyForm.licenseUsefulLifeType ===0">
            <el-date-picker
              v-model="companyForm.licenseUsefulLifeTime"
              class="demo-ruleForm-half-picker"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              >
            </el-date-picker>
            </template>
            <div class="remark-tip">请与资质照片上的有效期保持一致,若为长期有效证件请选择"无截止日期</div>
            </div>
          </el-form-item>
          <el-form-item label="法人/经营者">
            <el-input v-noEmoji v-model="companyForm.legalPerson" placeholder="请与照片中的法人/经营者保持一致" class="demo-ruleForm-input"/>
          </el-form-item>
          <el-form-item label="法人身份证">
              <div class="demo-ruleForm-box">
            <el-upload
              class="avatar-uploader-card"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleIdentitySuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="companyForm.identityCardFront !== ''" :src="companyForm.identityCardFront" class="avatar">
              <div v-else class="text-wrapper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="text-title">法人身份证正面</div>
                <div class="text-tip">jpeg/png,小于5M</div>
              </div>
            </el-upload>
            <el-upload
              class="avatar-uploader-card avatar-uploader-opposite-img"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleCardContrarySuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="companyForm.identityCardContrary !== ''" :src="companyForm.identityCardContrary" class="avatar">
              <div v-else class="text-wrapper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="text-title">法人身份证反面</div>
                <div class="text-tip">jpeg/png,小于5M</div>
              </div>
            </el-upload>
              </div>
          </el-form-item>
          <el-form-item label="法人身份证号">
            <el-input v-noEmoji v-model="companyForm.identityCardNo" placeholder="请输入法人身份证号" class="demo-ruleForm-input"></el-input>
          </el-form-item>
          <el-form-item label="注册地">
             <div class="demo-ruleForm-box">
            <el-select v-model="regAddress.provincesId" placeholder="请选择" class="demo-ruleForm-half-select" @change="handleRegionsDataChange">
                <el-option v-for="item in regionsData" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="regAddress.regionId" placeholder="请选择" class="demo-ruleForm-half-select">
                <el-option v-for="item in regionsDataChild" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div class="remark-tip">请与资质照片上的注册地保持一致,若下拉列表中无该注册地城市,请联系销售或运营</div>
             </div>
          </el-form-item>
          <el-form-item label="关联业务员" v-if="relateAgentAccountList.length">
            <el-select v-model="companyForm.agentAccountIdList" multiple filterable clearable class="demo-ruleForm-input" placeholder="请选择" @change="handleRegionsDataChange">
              <el-option v-for="item in relateAgentAccountList" :key="item.agentAccountId" :label="item.agentAccountName" :value="item.agentAccountId"></el-option>
            </el-select>
          </el-form-item>
      </el-form>
       </template>
       <template v-else>
          <el-form
          class="demo-ruleForm"
          label-width="120px"
          label-position="left"
          :model="presonForm"
          ref="presonForm"
          hide-required-asterisk
          :rules="personRules"
          key="person"
        >
        <el-form-item label="类型">
          <el-radio-group v-model="registerType" :disabled="mode === 'edit' && companyForm.partnerStatus === 0">
            <el-radio-button size="medium" :label="0">企业</el-radio-button>
            <el-radio-button size="medium" :label="1">个人</el-radio-button>
          </el-radio-group>
        </el-form-item>
          <el-form-item prop="partnerName"  :rules="[{ required: true, message: '请输入个人姓名', trigger: 'blur' }]">
            <span slot="label">
              <span>请输入个人姓名</span>
              <span class="sub-title">(必填)</span>
            </span>
            <el-input v-noEmoji v-model="presonForm.partnerName" placeholder="请输入个人姓名" class="demo-ruleForm-input"/>
          </el-form-item>
          <el-form-item prop="licenseType">
             <span slot="label">
              <span>证件类型</span>
              <span class="sub-title">(必填)</span>
            </span>
            <el-select v-model="presonForm.licenseType" placeholder="请选择" class="demo-ruleForm-select" >
                <el-option label="身份证号" :value="0"></el-option>
                <el-option label="护照号" :value="1"></el-option>
                <el-option label="个人港澳/台湾居民往来大陆通行证证号" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件照片" class="avatar-uploader-me">
            <div class="demo-ruleForm-box">
            <el-upload
              class="avatar-uploader-front-img"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleIdentitySuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="presonForm.identityCardFront !== ''" :src="presonForm.identityCardFront" class="avatar">
              <div v-else class="text-wrapper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="text-title">身份证正面</div>
                <div class="text-tip">jpeg/png,小于5M</div>
              </div>
            </el-upload>
            <el-upload
              class="avatar-uploader-front-img"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleCardContrarySuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="presonForm.identityCardContrary !== ''" :src="presonForm.identityCardContrary" class="avatar">
              <div v-else class="text-wrapper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="text-title">身份证反面</div>
                <div class="text-tip">jpeg/png,小于5M</div>
              </div>
            </el-upload>
            <el-upload
              class="avatar-uploader-front-img"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleLicenseSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="presonForm.license !== ''" :src="presonForm.license" class="avatar">
              <div v-else class="text-wrapper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="text-title">手持身份证照</div>
                <div class="text-tip">jpeg/png,小于5M</div>
              </div>
            </el-upload>
            </div>
          </el-form-item>
          <el-form-item prop="identityCardNo" :rules="[{ required: true, message: '请输入证件编号', trigger: 'blur' }]">
            <span slot="label">
              <span>证件编号</span>
              <span class="sub-title">(必填)</span>
            </span>
             <div class="demo-ruleForm-box">
              <el-input v-noEmoji v-model="presonForm.identityCardNo" placeholder="请先选择证件类型,再填写证件编号" class="demo-ruleForm-input"/>
            <div class="remark-tip">请确保所填身份证编号与身份证照片上的一致</div>
             </div>
          </el-form-item>
          <el-form-item label="证件有效期">
             <div class="demo-ruleForm-box">
                <el-select v-model="presonForm.licenseUsefulLifeType" placeholder="请选择" :class=" presonForm.licenseUsefulLifeType === 0 ? 'demo-ruleForm-half-select' : 'demo-ruleForm-select'">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <template v-if="presonForm.licenseUsefulLifeType ===0">
            <el-date-picker
              class="demo-ruleForm-half-picker"
              v-model="presonForm.licenseUsefulLifeTime"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              >
            </el-date-picker>
            </template>
            <div class="remark-tip">请与身份证照片上的有效期保持一致,若为长期有效证件请选择"无截止日期</div>
             </div>
          </el-form-item>
      </el-form>
       </template>
     </ContentBox>
      <ContentBox  class="content-box">
        <el-button @click="handleQuit"><i class="icon-ios-undo"></i>取消</el-button>
        <el-button :loading="saveBtnLoading" @click="handleSave(0)">保存草稿</el-button>
        <el-button type="primary" :loading="saveSubmitBtnLoading" :disabled="isDisabledBtn" @click="handleSave(1)">提交审核</el-button>
      </ContentBox>
  </div>
</template>
<script>

export default {
  props: ['mode', 'id'],
  data() {
    return {
      saveBtnLoading: false,
      saveSubmitBtnLoading: false,
      registerType: 0,
      companyForm: {
        agentAccountIdList: [],
        partnerId: undefined,
        registerType: 0,
        partnerName: '',
        companyNature: '',
        license: '',
        licenseSn: '',
        licenseUsefulLifeType: 0, // 0:短期有效，1:长期有效
        licenseUsefulLifeTime: '',
        legalPerson: '',
        identityCardFront: '',
        identityCardContrary: '',
        identityCardNo: '',
        registeredAddress: '',
        saveStatus: 0 // 0保存草稿，1送审

      },
      presonForm: {
        partnerId: undefined,
        registerType: 1,
        partnerName: '',
        licenseType: '',
        identityCardFront: '',
        identityCardContrary: '',
        license: '',
        identityCardNo: '',
        licenseUsefulLifeType: 0, // 0:短期有效，1:长期有效
        licenseUsefulLifeTime: '',
        saveStatus: 0 // 0保存草稿，1送审
      },
      personRules: {
        partnerName: [{ required: true }],
        licenseType: [{ required: true, message: '请选择证件类型', trigger: 'change' }]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      options: [
        {
          value: 0,
          label: '有效期至'
        }, {
          value: 1,
          label: '长期有效'
        }
      ],
      regAddress: {
        provincesId: '',
        regionId: '',
        agentAccountIdList: []
      },
      uploadImgUrl: 'api/dsp/adDspPartner/uploadFile',
      regionsData: [],
      regionsDataChild: [],
      relateAgentAccountList: [],
      oldForm: {}
    }
  },
  computed: {
    isDisabledBtn() {
      let isDisabled = true
      if (this.registerType === 0) {
        if (this.companyForm.partnerName) {
          isDisabled = false
        }
      } else {
        if (this.presonForm.partnerName && this.presonForm.identityCardNo && (this.presonForm.licenseType || this.presonForm.licenseType === 0)) {
          isDisabled = false
        }
      }
      return isDisabled
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const suffix = file.name.split('.').slice(-1)[0]
      const extension = suffix === 'jpg'
      const extension2 = suffix === 'jpeg'
      const extension3 = suffix === 'png'
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!extension && !extension2 && !extension3) {
        this.$message('上传图片格式必须为jpg/jpeg/png格式')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过5M!')
      }
      return (extension || extension2 || extension3) && isLt2M
    },
    handleLicenseSuccess(res, file) {
      if (res.code === 0) {
        if (this.registerType === 0) {
          this.companyForm.license = res.data.mediaIcon
        } else {
          this.presonForm.license = res.data.mediaIcon
        }
      }
    },
    handleIdentitySuccess(res, file) {
      if (res.code === 0) {
        if (this.registerType === 0) {
          this.companyForm.identityCardFront = res.data.mediaIcon
        } else {
          this.presonForm.identityCardFront = res.data.mediaIcon
        }
      }
    },
    handleCardContrarySuccess(res, file) {
      if (res.code === 0) {
        if (this.registerType === 0) {
          this.companyForm.identityCardContrary = res.data.mediaIcon
        } else {
          this.presonForm.identityCardContrary = res.data.mediaIcon
        }
      }
    },
    getAdAgentAccountList() {
      const params = {
        flag: 2
      }
      this.$service.getAdAgentAccountList(params).then(data => {
        this.relateAgentAccountList = data
      }).catch(() => {
      })
    },
    getRegionList() {
      this.$service.getRegionList({}).then(data => {
        const areaData = data.slice().filter(item => {
          return item.name !== '未匹配'
        })
        areaData.forEach(item => {
          if (item.parent === 0) {
            this.regionsData.push({
              value: item.regionId,
              label: item.name,
              children: []
            })
          }
        })
        for (let i = 0; i < this.regionsData.length; i++) {
          for (let j = 0; j < areaData.length; j++) {
            if (areaData[j].parent === this.regionsData[i].value) {
              this.regionsData[i].children.push({
                value: areaData[j].regionId,
                label: areaData[j].name
              })
            }
          }
        }
        if (this.mode === 'edit') {
          this.getAccAdDspPartnerDetail()
        } else {
          this.oldForm = JSON.parse(JSON.stringify(this.companyForm))
        }
      }).catch(() => {
      })
    },
    handleRegionsDataChange() {
      const regData = this.regionsData
      for (let i = 0; i < regData.length; i++) {
        if (regData[i].value === this.regAddress.provincesId) {
          this.regionsDataChild = regData[i].children
          break
        }
      }
    },
    handleQuit() {
      const newForm = this.registerType === 0 ? this.companyForm : this.presonForm
      const isChange = this.$consts.difference(newForm, this.oldForm)
      if (Object.keys(isChange).length > 0) {
        this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
          confirmButtonText: '离开页面',
          cancelButtonText: '留在页面',
          center: true,
          type: 'warning'
        })
          .then(() => {
            this.$emit('go-back', false)
          }).catch(() => {
          })
      } else {
        this.$emit('go-back', false)
      }
    },
    handleSave(val) {
      if (this.registerType === 0) {
        this.$refs.companyForm.validate((valid) => {
          if (valid) {
            this.saveBtnLoading = true
            this.handleSaveInfo(this.companyForm, val)
          }
        })
      } else {
        this.$refs.presonForm.validate((valid) => {
          if (valid) {
            this.saveSubmitBtnLoading = true
            this.handleSaveInfo(this.presonForm, val)
          }
        })
      }
    },
    handleSaveInfo(form, type) {
      const params = this.cloneDeep(form)
      params.saveStatus = type
      params.registeredAddress = this.regAddress.provincesId + ',' + this.regAddress.regionId
      if (params.licenseUsefulLifeType === 1) {
        params.licenseUsefulLifeTime = undefined
      }
      params.identityCardNo = params.identityCardNo ? this.$encrypt(params.identityCardNo) : ''
      if (this.mode === 'edit') {
        this.$service.getAccAdDspPartnerEdit(params, '操作成功').then(data => {
          this.saveBtnLoading = false
          this.saveSubmitBtnLoading = false
          this.$emit('go-back', true)
        }).catch(() => {
          this.saveBtnLoading = false
          this.saveSubmitBtnLoading = false
        })
      } else {
        this.$service.getAccAdDspPartnerAdd(params, '操作成功').then(data => {
          this.saveBtnLoading = false
          this.saveSubmitBtnLoading = false
          this.$emit('go-back', true)
        }).catch(() => {
          this.saveBtnLoading = false
          this.saveSubmitBtnLoading = false
        })
      }
    },
    getAccAdDspPartnerDetail() {
      this.$service.getAccAdDspPartnerDetail({ partnerId: this.id }).then(data => {
        this.registerType = data.registerType
        this.companyForm.partnerId = data.partnerId
        this.presonForm.partnerId = data.partnerId
        if (this.registerType === 1) {
          this.presonForm.partnerName = data.partnerName
          this.presonForm.licenseType = data.licenseType
          this.presonForm.identityCardFront = data.identityCardFront
          this.presonForm.identityCardContrary = data.identityCardContrary
          this.presonForm.license = data.license
          this.presonForm.identityCardNo = this.$decrypt(data.identityCardNo)
          this.presonForm.licenseUsefulLifeType = data.licenseUsefulLifeType
          this.presonForm.licenseUsefulLifeTime = data.licenseUsefulLifeTime
          this.oldForm = JSON.parse(JSON.stringify(this.presonForm))
        } else {
          this.companyForm.agentAccountIdList = data.agentAccountIdList || []
          this.companyForm.partnerName = data.partnerName
          this.companyForm.companyNature = data.companyNature
          this.companyForm.license = data.license
          this.companyForm.licenseSn = data.licenseSn
          this.companyForm.licenseUsefulLifeType = data.licenseUsefulLifeType
          this.companyForm.licenseUsefulLifeTime = data.licenseUsefulLifeTime
          this.companyForm.legalPerson = data.legalPerson
          this.companyForm.identityCardFront = data.identityCardFront
          this.companyForm.identityCardContrary = data.identityCardContrary
          this.companyForm.identityCardNo = this.$decrypt(data.identityCardNo)
          const addr = data.registeredAddress.split(',')
          if (addr[0]) this.regAddress.provincesId = parseInt(addr[0])
          if (addr[1]) this.regAddress.regionId = parseInt(addr[1])
          this.handleRegionsDataChange()
          this.oldForm = JSON.parse(JSON.stringify(this.companyForm))
        }
      }).catch(() => {
      })
    },
    querySearchAsync(queryString, cb) {
      this.$service.getCrmCustomer({ cumName: queryString }).then(res => {
        const options = res.slice(0, 10)
        cb(options)
      })
    }
  },
  created() {
    this.getRegionList()
    this.getAdAgentAccountList()
  }
}
</script>
<style lang="stylus" scoped>
.content-container {
  margin: 16px;
}

>>>.title {
  padding-left: 32px;
}

>>>.content-box__main {
  margin-left: 32px;
}
>>>.el-radio-button__inner {
  width: 232px;
}
.demo-ruleForm-box .demo-ruleForm-half-select,.demo-ruleForm-half-picker
  width 231px
.demo-ruleForm-box .demo-ruleForm-half-select:nth-child(1) {
  margin-right 2px
}
.demo-ruleForm-input,.demo-ruleForm-select,.demo-ruleForm-picker {
  width 464px
}
>>>.el-select
  display flex
 .demo-ruleForm-box {
  display flex
  align-items center
}
.remark-tip {
  min-width:317px;
  height:22px;
  font-size:12px;
  font-weight:400;
  color:rgba(0,0,0,0.45);
  line-height:22px;
  padding-left 8px
}
.demo-ruleForm-box .avatar-uploader>>>.el-upload
  height 180px
  width 462px
  height 130px

.avatar-uploader >>>.el-upload,.avatar-uploader-card >>>.el-upload,.avatar-uploader-front-img >>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader >>>.el-upload:hover,.avatar-uploader-card >>>.el-upload:hover,.avatar-uploader-front-img >>>.el-upload:hover {
    border-color: #ff8b00;
  }
  .avatar-uploader-icon {
    font-size: 24px;
    color: #8c939d;
    text-align: center;
  }
.avatar-uploader img,
.avatar-uploader-card img,
.avatar-uploader-front-img img
  max-width 100%
  max-height 100%
.demo-ruleForm-box .avatar-uploader-card>>>.el-upload:nth-child(1),.demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload {
  margin-right 2px
}
.demo-ruleForm-box .avatar-uploader-card>>>.el-upload {
  width 229px
  height 130px
}
.avatar-uploader-front-img >>>.el-upload {
  width 151px
  height 130px
}
.demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(3) {
  width 152px
  margin-right 0
}
.avatar-uploader-card
  // background url('../../assets/id-card-front.png') no-repeat
  background-size 100% 100%
  display inline-block
  align-items center
  justify-content center
  flex-direction column
  position relative
  vertical-align top
  height 130px
.avatar-uploader-opposite-img
  background-size 100% 100%
.avatar-uploader-none-img
  background-size 100% 100%
.avatar-uploader-card .text-wrapper
  text-align center
.avatar-uploader .avatar-uploader-icon
  margin-top 35px
>>>.avatar-uploader-icon
  font-size 24px
  margin-top 35px
.text-tip
  padding: 0 32px 0px 34px;
  font-size: 12px;
  color: rgba(0,0,0,0.45);
  height: 16px;
  line-height: 16px;
.text-title
  color:rgba(0,0,0,0.85);
  font-size:12px;
  height 22px
  line-height 22px
.avatar-uploader-front-img .text-tip
  padding 0
.sub-title
   color rgba(0,0,0,0.65)
   padding 0 5px
.el-autocomplete
  width 464px
</style>
